import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useBusinessCustomer } from "../../../sevices/hooks/account";
import OnboardingTable from "../../../components/businessOnboardingTable";
import SearchComponent from "../../../components/dashboard-components/SearchComponent";
import _ from "lodash";

const Onboarding = () => {

  const [searchParams] = useSearchParams();
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState(
    searchParams.get("search") || ""
  );
  const { data: businessUser, isLoading } = useBusinessCustomer({
    pageSize,
    page,
    // refereeCode: searchTerm,
    // name: searchTerm,
    search: searchTerm,
    // email: searchTerm,
  });

  const [debouncedSearchTerm] = useState(() =>
    _.debounce((term: string) => {
      setSearchTerm(term);
      setPage(1);
    }, 500)
  );

  const handleSearch = (value: string) => {
    debouncedSearchTerm(value);
  };

  return (
    <div className="h-screen w-full bg-[#FEFEFF] p-5 md:pr-5 md:pl-8 ">
      <div className="flex flex-row items-center justify-between  my-8">
        <h1 className="font-bold text-2xl text-[#071827] md:pb-2">
          Customer Onboarding
        </h1>
      </div>
      <div>
        <SearchComponent
          placeholder={"Search business"}
          onSearch={(e) => handleSearch(e)}
        />
      </div>
      <div className="">
        <div>
          <OnboardingTable
            data={businessUser?.data?.data || []}
            isLoading={isLoading}
            page={page}
            totalPages={businessUser?.data?.data?.totalPages}
            onPageChange={setPage}
            searchTerm={searchTerm}
            isBusiness={true}
          />
        </div>
      </div>
    </div>
  );
};

export default Onboarding;
